<div
	class="viewport-container"
	[style.top]="yOffset + 'px'"
	[style.height]="windowHeight + 'px'"
>
	<ng-content></ng-content>
</div>
